module.exports = __webpack_public_path__ + "static/media/DC_F_Timeless_Sforza_Bordeaux.21d6646f.png";